import { render, staticRenderFns } from "./IdentifyCenter.vue?vue&type=template&id=70bb5ff6&scoped=true&"
import script from "./IdentifyCenter.vue?vue&type=script&lang=js&"
export * from "./IdentifyCenter.vue?vue&type=script&lang=js&"
import style0 from "./IdentifyCenter.vue?vue&type=style&index=0&id=70bb5ff6&prod&lang=scss&scoped=true&"
import style1 from "./IdentifyCenter.vue?vue&type=style&index=1&id=70bb5ff6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb5ff6",
  null
  
)

export default component.exports